export default class BlockoutDateCreation {
  public dates: string[];

  constructor(dates: string[]) {
    this.dates = dates;
  }
}
